import { type ComponentPropsWithRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Input as UIInput } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const singleInputVariants = cva(
    [
        'h-12 rounded-none border-snk-keyline-grey shadow-none font-light transition-colors duration-200 ease-in-out',
        'focus:!border-primary focus-visible:!border-primary focus:!ring-0 focus-visible:!ring-0 focus:!ring-transparent focus-visible:!ring-transparent',
        'disabled:!border-snk-keyline-grey disabled:!text-muted-foreground disabled:!opacity-100 disabled:placeholder:text-muted-foreground/70 disabled:bg-snk-disabled',
    ].join(' '),
    {
        variants: {
            validationState: {
                default: '',
                success: 'border-success focus:!border-success focus-visible:!border-success',
                error: 'border-destructive focus:!border-destructive focus-visible:!border-destructive',
            },
        },
        defaultVariants: {
            validationState: 'default',
        },
    }
);

export type SingleInputProps = ComponentPropsWithRef<typeof UIInput> & VariantProps<typeof singleInputVariants>;

export const SingleInput = ({ className, ref, validationState, ...props }: SingleInputProps) => {
    return <UIInput {...props} className={cn(singleInputVariants({ validationState }), className)} ref={ref} />;
};
